import { create } from 'zustand';
import { getUsageSummary, type UsageSummary } from "~/lib/network/billing";

interface CoinUsageStore {
  usageSummary: UsageSummary | null;
  isLoading: boolean;
  error: string | null;
  fetchUserCoinUsage: () => Promise<void>;
}

// Separate non-persisted store for coin usage
// This is NOT part of the global store to avoid infinite loops
export const useCoinUsageStore = create<CoinUsageStore>((set) => ({
  usageSummary: null,
  isLoading: false,
  error: null,
  fetchUserCoinUsage: async () => {
    set({ isLoading: true, error: null });
    try {
      const summary = await getUsageSummary();
      set({ usageSummary: summary, isLoading: false, error: null });
    } catch (error) {
      console.error("Failed to fetch usage summary:", error);
      set({
        isLoading: false,
        error: error instanceof Error ? error.message : "Failed to fetch usage",
      });
    }
  },
}));
